{
  "name": "vegan-ipsum",
  "version": "2.0.1",
  "description": "Generates passages of vegan-themed placeholder text suitable for use in web pages, graphics, and more. Works in the browser, NodeJS, and React Native.",
  "scripts": {
    "build:js": "vite build",
    "build:bin": "vite build --config vitebin.config.ts",
    "build:exec": "chmod +x dist/bin/vegan-ipsum.bin.js",
    "build": "bun run build:js && bun run build:bin && bun run build:exec",
    "postbuild": "find ./types -type f -name \"*.config.d*\" -delete && rm -rf types/tests/local/",
    "lint": "eslint . --ext .ts,.tsx,.js,.mjs",
    "lint:fix": "eslint . --fix --ext .ts,.tsx,.js,.mjs",
    "format": "prettier --write --log-level error .",
    "format:check": "prettier --check --log-level error .",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "test:local": "node tests/local/test-cjs.js && node tests/local/test-esm.mjs && node tests/local/test-interop-cjs.js",
    "tsc": "tsc --noEmit",
    "release": "release-it",
    "release:dry": "release-it --dry-run",
    "prepare": "husky"
  },
  "license": "MIT",
  "author": {
    "name": "Vijay Hardaha",
    "url": "http://github.com/vijayhardaha"
  },
  "homepage": "https://github.com/vijayhardaha/node-vegan-ipsum#readme",
  "repository": {
    "type": "git",
    "url": "git://github.com/vijayhardaha/node-vegan-ipsum.git"
  },
  "bugs": {
    "url": "https://github.com/vijayhardaha/node-vegan-ipsum/issues"
  },
  "files": [
    "dist",
    "src",
    "types",
    "LICENSE",
    "README.md"
  ],
  "main": "dist/index.cjs",
  "module": "dist/index.mjs",
  "types": "types/src/index.d.ts",
  "bin": {
    "vegan-ipsum": "dist/bin/vegan-ipsum.bin.js"
  },
  "exports": {
    ".": {
      "types": "./types/src/index.d.ts",
      "import": "./dist/index.mjs",
      "require": "./dist/index.cjs"
    },
    "./bin/vegan-ipsum.bin.js": {
      "require": "./dist/bin/vegan-ipsum.bin.js"
    }
  },
  "keywords": [
    "cli",
    "filler",
    "generator",
    "ipsum",
    "lorem",
    "lorem-ipsum",
    "node",
    "placeholder",
    "placeholder-text",
    "plant-based",
    "typescript",
    "vegan",
    "vegan-ipsum"
  ],
  "engines": {
    "node": ">= 20.x",
    "npm": ">= 9.x"
  },
  "dependencies": {
    "commander": "^14.0.3"
  },
  "devDependencies": {
    "@commitlint/cli": "^21.0.1",
    "@commitlint/config-conventional": "^21.0.1",
    "@commitlint/types": "^21.0.1",
    "@eslint/compat": "^2.1.0",
    "@eslint/eslintrc": "^3.3.5",
    "@eslint/js": "^9.39.4",
    "@prettier/plugin-xml": "^3.4.2",
    "@types/node": "^25.9.1",
    "@types/random-seed": "^0.3.5",
    "@typescript-eslint/eslint-plugin": "^8.60.0",
    "@typescript-eslint/parser": "^8.60.0",
    "@vijayhardaha/dev-config": "^1.1.4",
    "@vitest/coverage-v8": "4.1.7",
    "eslint": "^9.39.4",
    "eslint-config-prettier": "^10.1.8",
    "eslint-import-resolver-typescript": "^4.4.4",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jsx-a11y": "^6.10.2",
    "eslint-plugin-prettier": "^5.5.6",
    "globals": "^17.6.0",
    "husky": "^9.1.7",
    "nock-exec": "^0.1.0",
    "prettier": "^3.8.3",
    "release-it": "^20.0.1",
    "rollup": "^4.60.4",
    "typescript": "^6.0.3",
    "vite": "^8.0.14",
    "vite-plugin-dts": "^5.0.1",
    "vitest": "^4.1.7"
  }
}
